/**
 * Local vs next-day cart lines.
 * Local same-city: product has tag city_<slug> matching the customer's city (e.g. city_mumbai + user in Mumbai) → local delivery.
 * If the tag city does not match the user's city (or there is no matching city_* tag), the cart treats the line as next-day delivery.
 * Loaded before skipp-delivery-eta.js and skipp-scheduled-delivery.js
 */
(function (global) {
  function slugifyCity(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '');
  }

  /** Same metro / alternate spellings so city_* tags still match shopper location. */
  const CITY_SLUG_ALIASES = {
    bangalore: ['bengaluru'],
    bengaluru: ['bangalore'],
    bombay: ['mumbai'],
    mumbai: ['bombay'],
  };

  function tagCitySlugMatchesUserCity(tagSlug, userSlug) {
    if (!tagSlug || !userSlug) return false;
    if (tagSlug === userSlug) return true;
    const fromTag = CITY_SLUG_ALIASES[tagSlug];
    if (fromTag && fromTag.includes(userSlug)) return true;
    const fromUser = CITY_SLUG_ALIASES[userSlug];
    if (fromUser && fromUser.includes(tagSlug)) return true;
    return false;
  }

  function getUserCitySlug() {
    if (typeof global.__SKIPP_USER_CITY_SLUG__ === 'string' && global.__SKIPP_USER_CITY_SLUG__) {
      return slugifyCity(global.__SKIPP_USER_CITY_SLUG__);
    }
    try {
      const raw = localStorage.getItem('userLocation');
      if (raw) {
        const j = JSON.parse(raw);
        const c = j.cityName || j.city || '';
        if (c) return slugifyCity(c);
      }
    } catch {
      /* ignore */
    }
    const loc = global.multiVendorCart?.userLocation;
    const c2 = loc?.cityName || loc?.city;
    if (c2) return slugifyCity(c2);
    return '';
  }

  function parseTagsAttr(attr) {
    if (!attr) return [];
    return String(attr)
      .split('|')
      .map((t) => t.trim())
      .filter(Boolean);
  }

  function isExpressProduct(tags, citySlug) {
    if (!citySlug) return false;
    const lower = tags.map((t) => String(t).trim().toLowerCase());
    if (!lower.includes('express')) return false;
    for (let i = 0; i < lower.length; i += 1) {
      const t = lower[i];
      if (t.startsWith('city_')) {
        const rest = slugifyCity(t.slice(5).replace(/_/g, ' '));
        if (rest && tagCitySlugMatchesUserCity(rest, citySlug)) return true;
      }
    }
    return false;
  }

  /** True when any city_* tag matches the user's city (same-city assortment = local ~30 min delivery). */
  function isCityTagMatchesUser(tags, citySlug) {
    if (!citySlug) return false;
    const lower = tags.map((t) => String(t).trim().toLowerCase());
    for (let i = 0; i < lower.length; i += 1) {
      const t = lower[i];
      if (t.startsWith('city_')) {
        const rest = slugifyCity(t.slice(5).replace(/_/g, ' '));
        if (rest && tagCitySlugMatchesUserCity(rest, citySlug)) return true;
      }
    }
    return false;
  }

  /** Local delivery line: matching city tag for user's location (includes legacy express + city). */
  function isLocalCityCartProduct(tags, citySlug) {
    if (!citySlug) return false;
    return isCityTagMatchesUser(tags, citySlug);
  }

  function rowIsExpress(row, citySlug) {
    if (!row) return false;
    const tags = parseTagsAttr(row.getAttribute('data-product-tags'));
    return isLocalCityCartProduct(tags, citySlug);
  }

  /**
   * @returns {{ citySlug: string, expressLineKeys: Set<string>, expressVendors: string[] }}
   */
  function getExpressCartContext(cartData) {
    const citySlug = getUserCitySlug();
    const expressLineKeys = new Set();
    const vendorSet = new Set();

    global.document.querySelectorAll('tr.cart-item[data-cart-line-key]').forEach((row) => {
      if (!rowIsExpress(row, citySlug)) return;
      const key = row.getAttribute('data-cart-line-key');
      if (key) expressLineKeys.add(key);
      const v = row.getAttribute('data-vendor');
      if (v) vendorSet.add(String(v).trim());
    });

    const expressVendors = [];
    if (cartData?.items && expressLineKeys.size) {
      cartData.items.forEach((item) => {
        if (item.key && expressLineKeys.has(item.key) && item.vendor) {
          expressVendors.push(String(item.vendor).trim());
        }
      });
    }

    return {
      citySlug,
      expressLineKeys,
      expressVendors: [...new Set(expressVendors)],
    };
  }

  global.SkippCartDeliveryRules = {
    slugifyCity,
    tagCitySlugMatchesUserCity,
    getUserCitySlug,
    parseTagsAttr,
    isExpressProduct,
    isCityTagMatchesUser,
    isLocalCityCartProduct,
    rowIsExpress,
    getExpressCartContext,
  };
})(typeof window !== 'undefined' ? window : globalThis);
